import { createBrowserRouter } from "react-router-dom";

// project imports
import LoginPage from "pages/auth/Login";
import NotFoundPage from "pages/maintenance/404";
import MainRoutes from "./MainRoutes";

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    MainRoutes,
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME },
);

export default router;
